var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLimitedTimeOffer)?_c('div',{staticClass:"offer font-weight-medium font-0 py-1 w100",class:_vm.alignment},[_c('span',[_vm._v("Termina en "),_c('strong',[_vm._v(_vm._s(_vm.limitedTimeOfferMsg))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }